"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var SearchMapAction_1 = require("@/pages/search/actions/SearchMapAction");
var format_1 = require("@/utils/format");
var searchResponseToResultPage_1 = require("@/transformers/searchResponseToResultPage");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var propertyToUrl_1 = require("@/transformers/propertyToUrl");
var classnames_1 = require("classnames");
var mapDispatchToProps = function (dispatch) { return ({
    removeActivePins: function () { return dispatch(SearchMapAction_1.default.removeActivePins()); },
    toggleFav: function (id) { return dispatch(SearchMapAction_1.default.toggleFav(id)); },
}); };
var mapStateToProps = function (state) { return (__assign(__assign({}, state.mapsearch), { imgDomain: state.layout.imgDomain, properties: state.mapsearch.currentActivePins && state.mapsearch.currentActivePins.pins ?
        state.mapsearch.currentActivePins.pins.reduce(function (acc, it) { return acc.concat(it.value.properties); }, []) : [], lang: state.layout.language.languages.filter(function (it) { return it.id === state.layout.language.current; })[0].code1, symbol: state.layout.currencies.options.filter(function (it) { return it.key === state.layout.currencies.currentCurrencyId; })[0].symbol, t: state.results.t })); };
var searchMapList = function (props) {
    var onClose = function () { return props.removeActivePins(); };
    var renderProperty = function (property, index) {
        var favIds = props.favIds || [];
        var propertyPhotoes = [];
        if (property.propertyPhoto ||
            property.propertyPhoto === '') {
            propertyPhotoes = searchResponseToResultPage_1.photoStrToPhotos(property.propertyPhoto, property.id);
        }
        else {
            propertyPhotoes = property.propertyPhotos;
        }
        var images = [];
        images = propertyPhotoes.map(function (it) { return ({
            path: "" + searchResponseToResultPage_1.toPhotoPath(it.photoName, it.photoType, props.imgDomain),
            caption: searchResponseToResultPage_1.photoTypeMap[it.photoType.toUpperCase()],
        }); });
        var url = '';
        url = propertyToUrl_1.propertyToUrl(props.lang, property.buildingName, property.id, SfilterTypeGroup_1.ListingPurposeType.toSfilterType(property.listingTypeId));
        var renderImage = function () {
            return images.length ? (React.createElement("div", { className: "c-mappop__pic" },
                React.createElement("img", { src: images.length ? images[0].path : '', alt: "" }))) : React.createElement("div", { className: "c-mappop__pic c-mappop__pic--nopic" });
        };
        var toggleFav = function () { return props.toggleFav(property.id); };
        var favBtnClass = classnames_1.default('c-mappop__btn', {
            'c-mappop__btn--active': favIds.indexOf(property.id) >= 0,
        });
        var renderPrice = function (item, symbol, t) {
            if (item.isSaleSTO || item.isLeaseSTO) {
                return t.subjectToOffer;
            }
            return format_1.default.currency(item.salePrice ? item.salePrice : item.leasePrice * 1000, symbol);
        };
        return (React.createElement("div", { key: index, className: "c-mappop__item" },
            renderImage(),
            React.createElement("div", { className: "c-mappop__info" },
                React.createElement("a", { href: url, className: "c-mappop__title" }, property.buildingName),
                React.createElement("div", { className: "c-mappop__main" },
                    React.createElement("div", { className: "c-mappop__body" },
                        React.createElement("div", { className: "c-mappop__price" }, renderPrice(property, props.symbol, props.t)),
                        React.createElement("div", { className: "c-mappop__details" },
                            React.createElement("div", { className: "c-mappop__detail" },
                                React.createElement("div", { className: "c-mappop__value" }, property.netSize),
                                React.createElement("div", { className: "c-mappop__unit" },
                                    props.t.sqft,
                                    " (",
                                    property.netSize ? props.t.saleable : props.t.gross,
                                    ")")),
                            React.createElement("div", { className: "c-mappop__detail" },
                                React.createElement("div", { className: "c-mappop__value" }, property.bedrooms),
                                React.createElement("div", { className: "c-mappop__unit" }, props.t.ba)),
                            React.createElement("div", { className: "c-mappop__detail" },
                                React.createElement("div", { className: "c-mappop__value" }, property.bathrooms),
                                React.createElement("div", { className: "c-mappop__unit" }, props.t.ba)))),
                    React.createElement("div", { className: "c-mappop__side" },
                        React.createElement("button", { onClick: toggleFav, className: favBtnClass }))))));
    };
    return props.properties.length ? (React.createElement("div", { className: "l-search__listwrap" },
        React.createElement("div", { onClick: onClose, className: "c-mappop__close" },
            React.createElement("span", { className: "fal fa-times" })),
        React.createElement("div", { className: "c-mappop__head" },
            React.createElement("div", { className: "c-mappop__header" },
                props.properties.length,
                ' ',
                props.properties.length > 1 ? props.t.units : props.t.unit)),
        React.createElement("div", { className: "c-mappop__items" }, props.properties.map(renderProperty)))) : null;
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(searchMapList);
